export const handleError = (e: any) => {
  console.log('[ERROR]: ', e)
  throw new Error('Noe gikk galt')
}
